const FREE_MODES = ['', 'free', 'free_ads'];

/**
 * A video saved as "Same as collection" ('folder') in a Free collection is free. The play/buy rules
 * on both album pages only know free / paid / subscription, so without this such videos showed no Play.
 * In a Paid or Subscription collection 'folder' stays: the album purchase or plan unlocks it.
 */
export function albumVideoPaymentMode(videoMode: string, albumMode: string): string {
  if (videoMode === 'folder' && FREE_MODES.includes(albumMode || '')) return albumMode || 'free';
  return videoMode;
}

/** A known length of at least one second; uploads the browser could not read are saved as 0. */
export function hasVideoDuration(seconds: any): boolean {
  return Number(seconds) >= 1;
}
